export const BasicMonthlySubscriptionConstants = {
  DefaultValueForReserveSeatsField: 0,
  DefaultValueForMinimumUsageField: 0,
  DefaultValueForAutoRenewalField: 12,

  DisabledValueForAutoRenewalField: 0,
  DisabledValueForMinimumUsageField: 0,
  DisabledValueForEndDateFormField: 0,

  MinValueForReserveSeatsValidator: 1,
  MinValueForReserveSeatsFieldInput: 0,

  MinValueForAutoRenewalValidator: 1,
  MaxValueForAutoRenewalValidator: 100,
  MinValueForAutoRenewalFieldInput: 0,

  MinValueForMinimumUsageValidator: 1,
  MinValueForMinimumUsageFieldInput: 0,
};
